import React, { useEffect, useRef, useState } from "react";
import CustomDropdown from "../../../../components/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import { Calendar } from "primereact/calendar";
// import ConfirmDialog from "../../../../components/ConfirmDialog";
import { ProgressSpinner } from "primereact/progressspinner";
import {
  getBreadcrumbLabelsByAssetType,
  truncateText,
} from "../../../../utility/helper";
import { currencyOption, dateModeOptions } from "../../../../utility/data";
import FortuneComponent from "./wealthComponent/fortune";
import DetailsComponent from "./wealthComponent/details/index";
import LegacyComponent from "./wealthComponent/legacy/legacy";
import {
  startLoading,
  stopLoading,
} from "../../../../redux/slices/loaderSlice";

import {
  getDetailsAssetService,
  getDetailsInnerService,
  getFortuneService,
  getLegacyDataService,
} from "../../../../services/viewWealth";
import moment from "moment";
import {
  fetchGroups,
  resetGroupsState,
} from "../../../../redux/slices/groupsSlice";
import { useNavigate } from "react-router-dom";
import { handleErrorRedirect } from "../../../../utility/errorRedirect";
import Breadcrumb from "../../../../components/Breadcrumb";
const WealthView = () => {
  const [selectedButton, setSelectedButton] = useState("Fortune");
  const [limit, setLimit] = useState(20);
  const [page, setPage] = useState(0);
  const { createdAt } = useSelector((state) => state.user);
  const [dateMode, setDateMode] = useState("ytd");
  const [dateRange, setDateRange] = useState([
    moment(createdAt || moment().subtract(1, "month")).toDate(),
    moment().toDate(),
  ]);
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const toast = useRef(null);
  // const [isDialogOpen, setIsDialogOpen] = useState(false);
  // const [dialogConfig, setDialogConfig] = useState({});
  const [leagcyData, setLeagcyData] = useState([]);
  const [fortuneData, setFortuneData] = useState([]);
  const [viewDetails, setViewDetails] = useState([]);
  const [viewInnerDetails, setViewInnerDetails] = useState([]);
  const [graphDetails, setGraphDetails] = useState([]);
  const { currency } = useSelector((state) => state.user);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const breadcrumbItems = getBreadcrumbLabelsByAssetType("Wealth View");

  const { groupsData } = useSelector((state) => state.groups);
  const theme = useSelector((state) => state.theme.mode);
  const loadingCount = useSelector((state) => state.loader.loadingCount);
  const globalLoading = loadingCount > 0;

  useEffect(() => {
    if (accessToken) {
      dispatch(fetchGroups(accessToken)).then((resultAction) => {
        if (fetchGroups.rejected.match(resultAction)) {
          const status = resultAction?.payload?.status;
          handleErrorRedirect(status, navigate);
        }
      });
    }

    return () => {
      dispatch(resetGroupsState());
    };
  }, [dispatch, accessToken, navigate]);

  useEffect(() => {
    if (dateRange && dateRange.length === 2) {
      const [startDate, endDate] = dateRange.map((date) =>
        moment(date).format("YYYY-MM-DD")
      );

      if (startDate && endDate !== "Invalid date") {
        GetWealthFortuneData(dateMode, startDate, endDate);
        GetWealthLegacyData(dateMode, startDate, endDate);
        GetDetailsAssetTableData(dateMode, startDate, endDate);
      }
    }
  }, [dateRange, dateMode]);

  useEffect(() => {
    if (dateRange && dateRange.length === 2 && selectedAsset) {
      const [startDate, endDate] = dateRange.map((date) =>
        moment(date).format("YYYY-MM-DD")
      );

      if (startDate && endDate !== "Invalid date") {
        GetDetailsInnerTableData(dateMode, selectedAsset, startDate, endDate);
      }
    }
  }, [dateRange, selectedAsset, dateMode]);

  useEffect(() => {
    if (selectedButton) {
      setSelectedAsset(null);
      setSelectedDetail(null);
      setViewInnerDetails([]);
    }
  }, [selectedButton]);

  const GetDetailsAssetTableData = async (type, startDate, endDate) => {
    dispatch(startLoading());
    try {
      const response = await getDetailsAssetService(
        type,
        startDate,
        endDate,
        accessToken
      );
      if (response.status === 200) {
        setViewDetails(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      dispatch(stopLoading());
    }
  };

  const GetDetailsInnerTableData = async (
    type,
    selectedAsset,
    startDate,
    endDate
  ) => {
    dispatch(startLoading());
    try {
      const response = await getDetailsInnerService(
        type,
        selectedAsset,
        startDate,
        endDate,
        accessToken
      );
      if (response.status === 200) {
        setViewInnerDetails(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      dispatch(stopLoading());
    }
  };

  const GetWealthLegacyData = async (type, startDate, endDate) => {
    dispatch(startLoading());
    try {
      const response = await getLegacyDataService(
        type,
        startDate,
        endDate,
        accessToken
      );
      if (response.status === 200) {
        setLeagcyData(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      if (toast.current) {
        toast.current.show({
          className: "bg-yellow-700 text-white",
          severity: "warn",
          summary: "Warning",
          detail: err.message,
          life: 3000,
        });
      }
    } finally {
      dispatch(stopLoading());
    }
  };

  const GetWealthFortuneData = async (type, startDate, endDate) => {
    dispatch(startLoading());
    try {
      const response = await getFortuneService(
        type,
        startDate,
        endDate,
        accessToken
      );
      if (response.status === 200) {
        setFortuneData(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      if (toast.current) {
        toast.current.show({
          className: "bg-yellow-700 text-white",
          severity: "warn",
          summary: "Warning",
          detail: err.message,
          life: 3000,
        });
      }
    } finally {
      dispatch(stopLoading());
    }
  };

  const handleCalendarHide = () => {
    if (dateRange && dateRange.length === 2) {
      const [startDate, endDate] = dateRange;
      if (startDate && !endDate) {
        setViewDetails([]);
        setViewInnerDetails([]);
        setGraphDetails([]);
        setLeagcyData([]);
        setFortuneData([]);
        if (toast.current) {
          toast.current.show({
            className: "bg-yellow-700 text-white",
            severity: "warn",
            summary: "Warning",
            detail: "Please select end date",
            life: 3000,
          });
        }
      }
    }
  };

  const selectedDateModeOption = dateModeOptions.find(
    (opt) => opt.value === dateMode
  );

  return (
    <>
      <Toast ref={toast} />
      {/* <ConfirmDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        {...dialogConfig}
      /> */}
      <div className="relative">
        <Breadcrumb items={breadcrumbItems} className="md:ml-9" />
        <div className="md:flex justify-end md:gap-64 md:mr-10">
          <div className="flex gap-4 items-center">
            <CustomDropdown
              options={dateModeOptions}
              name={selectedDateModeOption.name}
              assetId={selectedDateModeOption.value}
              returnFullObject={true}
              onOptionSelect={(item) => setDateMode(item.value)}
              truncateText={truncateText}
              direction={"right"}
              size={19}
              className="text-lightPrimary dark:text-primary-gradient disabled:cursor-not-allowed inline-flex whitespace-nowrap justify-center px-1 py-1  items-center gap-1 text-base font-medium bg-transparent rounded-md border border-transparent hover:border-primary"
            />
            {dateMode === "ytd" && (
              <span className="text-lightPrimary dark:text-primary-gradient">
                YTD
              </span>
            )}
            {dateMode === "range" && (
              <Calendar
                value={dateRange}
                onChange={(e) => setDateRange(e.value)}
                selectionMode="range"
                onHide={handleCalendarHide}
                dateFormat="dd/mm/yy"
                maxDate={moment().toDate()}
                readOnlyInput
                placeholder="Select date range"
                className="wealth_date w-full text-lightPrimary dark:text-primary-gradient"
              />
            )}
          </div>
          <div className="flex gap-4 items-center">
            <span className="text-lightPrimary dark:text-grey">Currency</span>
            <CustomDropdown
              options={currencyOption}
              name={currency || "Select Currency"}
              assetId={currency || null}
              returnFullObject={true}
              truncateText={truncateText}
              disabled={true}
              direction={"right"}
              size={19}
              className="text-lightPrimary dark:text-primary-gradient cursor-not-allowed inline-flex whitespace-nowrap justify-center px-1 py-1.5  items-center gap-1 text-base font-medium bg-transparent rounded-md"
            />
          </div>
        </div>
        <div className="w-full overflow-x-auto">
          <div className="flex gap-8 item-baseline md:ml-10 overflow-x-auto">
            {[
              "Fortune",
              "Details",
              "Financial Profile",
              "Look for",
              "Legacy",
              "Insider",
            ].map((btn) => (
              <button
                key={btn}
                className={
                  selectedButton === btn
                    ? "text-lightPrimary dark:text-primary-gradient font-normal text-lg"
                    : "text-info dark:text-grey font-normal text-sm"
                }
                onClick={() => setSelectedButton(btn)}
              >
                {btn}
              </button>
            ))}
          </div>
        </div>
        {globalLoading ? (
          <div className="fixed top-[4.5rem] left-0 z-[9999] w-full h-full flex items-center justify-center bg-black bg-opacity-20">
            <ProgressSpinner style={{ width: "60px", height: "60px" }} />
          </div>
        ) : (
          <div className="mt-5">
            {selectedButton === "Fortune" && (
              <FortuneComponent
                fortuneData={fortuneData}
                theme={theme}
                groupsData={groupsData}
              />
            )}
            {selectedButton === "Legacy" && (
              <LegacyComponent
                leagcyData={leagcyData}
                handleOptionSelect={"handleOptionSelect"}
                confirmDelete={"confirmDelete"}
                setLimit={setLimit}
                limit={limit}
                setPage={setPage}
                page={page}
              />
            )}
            {selectedButton === "Details" && (
              <DetailsComponent
                viewDetails={viewDetails}
                viewInnerDetails={viewInnerDetails}
                setSelectedDetail={setSelectedDetail}
                setViewInnerDetails={setViewInnerDetails}
                selectedDetail={selectedDetail}
                selectedAsset={selectedAsset}
                graphDetails={graphDetails}
                setSelectedAsset={setSelectedAsset}
                handleOptionSelect={"handleOptionSelect"}
                confirmDelete={"confirmDelete"}
                setLimit={setLimit}
                limit={limit}
                setPage={setPage}
                page={page}
                selectedButton={selectedButton}
                groupsData={groupsData}
                detailBack={() => {
                  setSelectedAsset(null);
                  setSelectedDetail(null);
                  setViewInnerDetails([]);
                }}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default WealthView;
